import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M20.979 14.07a.75.75 0 0 1-.55.908l-2.31.563.606 2.26a.75.75 0 0 1-.53.919.8.8 0 0 1-.195.03.75.75 0 0 1-.724-.556l-.723-2.7-3.803-2.195v4.39l2.03 2.03a.75.75 0 1 1-1.06 1.062L12 19.06l-1.72 1.72a.752.752 0 0 1-1.223-.818.8.8 0 0 1 .162-.244l2.031-2.03V13.3L7.45 15.494l-.724 2.7a.75.75 0 0 1-1.45-.388l.605-2.26-2.31-.563a.75.75 0 0 1 .358-1.457l2.761.678L10.5 12 6.69 9.8l-2.76.678a.75.75 0 1 1-.358-1.457L5.88 8.46l-.606-2.265a.75.75 0 1 1 1.45-.388l.724 2.7L11.25 10.7V6.31L9.22 4.28a.75.75 0 0 1 1.06-1.062L12 4.94l1.72-1.72a.75.75 0 1 1 1.06 1.062l-2.03 2.03v4.39l3.802-2.195.723-2.7a.75.75 0 0 1 1.45.388l-.606 2.26 2.31.563a.75.75 0 0 1-.179 1.483.7.7 0 0 1-.179-.022l-2.76-.677L13.5 12l3.81 2.2 2.76-.678a.75.75 0 0 1 .907.549" />
  </>
);

const Snowflake = Icon('snowflake', svgContents);

export default Snowflake;
